import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from '../auth/auth.service';
// import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  private token: string;

  constructor(
    private http: HttpClient,
    // private auth: AuthService,

  ) {
    // auth.auth$.subscribe((user) => {
    //   this.token = user.token;
    // });
  }


  // get(url: string): Observable<any> {
  //   const headers = {
  //     'Content-Type': 'application/json',
  //     'Authorization': this.token
  //   };
  //   return this.http.get(environment.api_url + url,   );
  // }


  get(url: string): Observable<any> {
    let token= localStorage.getItem('token');
    // console.log(token);
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    };
    return this.http.get(environment.api_url + url,   );
  }
  addUser(user): Observable<any> {
    return this.http.post<any>(environment.api_url + `users/register`, user  );
  }

  updateUser(user): Observable<any> {
    return this.http.post<any>(environment.api_url + `users/updateUser`, user  );
  }

  deleteUser(user): Observable<any> {
    return this.http.post<any>(environment.api_url + `users/deleteMultipleUsers`, user );
  }

  post(url: string, body: any): Observable<any> {
    // console.log(this.token);
    let token= localStorage.getItem('token');
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    };
    return this.http.post(environment.api_url + url, body,   );
  }

  postFile(url: string, body: any): Observable<any> {
    // console.log(this.token);
    let token= localStorage.getItem('token');
    const headers = {
      // 'Content-Type': 'multipart/form-data',
      'Authorization': `Bearer ${token}`
    };
    return this.http.post(environment.api_url + url, body,   );
  }

  delete(url: string): Observable<any> {
    // console.log(this.token);
    let token= localStorage.getItem('token');
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    };

    return this.http.delete(environment.api_url + url,   );
  }
}
